import { lazy } from 'react';

import CustomLazyLoader from 'routes/CustomLazyLoader';

export const News = lazy(() => CustomLazyLoader(
  () => import('modules/news/containers/News'),
  'News'
));

export default News;
